import * as Constants from "../../../utils/constants";
import "./styles.scss";
import { WebEditorContext } from "../../../contexts";
import { useContext } from "react";
import { Menu, Transition, Popover } from "@headlessui/react";

export default function ActionMenuButton({
    hide,
    hideActionButtonText,
    label,
    icon,
    state,
    disabled,
    className,
    onClick,
    isPopover = false,
    popoverOptions = [],
}) {
    const { isLoading } = useContext(WebEditorContext);

    if (hide)
        return <></>

    if (isPopover) {
        return <PopoverActionMenuButtion
            hideActionButtonText={hideActionButtonText}
            label={label}
            icon={icon}
            state={state}
            disabled={disabled}
            className={className}
            onClick={onClick}
            isLoading={isLoading}
            options={popoverOptions}
        />
    }

    return (
        <button
            type="button"
            aria-label={label}
            className={`menu-button-tooltip-container tw-grid tw-justify-items-center tw-h-auto tw-rounded-sm tw-group ${className}`}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    onClick();
                }
            }}
            disabled={disabled}
        >
            {icon}
            {
                !hideActionButtonText &&
                <span className="tw-mt-1 tw-text-xs tw-text-center tw-text-gray-600 ">{label}</span>
            }
            {
                hideActionButtonText &&
                <span role="tooltip" id="predefined-tooltip-desc" className="menu-tooltip">{label}</span>
            }
        </button>
    )
}

const PopoverActionMenuButtion = ({
    hideActionButtonText,
    label,
    icon,
    state,
    disabled,
    className,
    onClick,
    options,
}) => {
    return (
        <Popover>
            <Popover.Button
                aria-label={label}
                className={`menu-button-tooltip-container tw-grid tw-justify-items-center tw-h-auto tw-rounded-sm tw-group ${className}`}
                disabled={disabled}
            >
                {icon}
                {
                    !hideActionButtonText &&
                    <span className="tw-mt-1 tw-text-xs tw-text-center tw-text-gray-600 ">{label}</span>
                }
                {
                    hideActionButtonText &&
                    <span role="tooltip" id="preview-tooltip-desc" className="menu-tooltip">{label}</span>
                }
            </Popover.Button>
            <Popover.Panel>
                {({ close }) => (
                    <div className="tw-origin-top-right tw-absolute tw-mt-2 tw-w-56 tw-rounded-md tw-shadow-lg tw-bg-white tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-z-10">
                        <div className="tw-py-1">
                            {options.map((option, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className="tw-block tw-px-4 tw-py-2 tw-text-sm tw-w-full tw-text-left tw-text-gray-700 hover:tw-bg-indigo-700 hover:tw-text-white hover:tw-no-underline 
                                        focus:outline-none focus:tw-bg-indigo-700 focus:tw-text-white focus:tw-no-underline"
                                    onClick={() => {
                                        option.onClick();
                                        close();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            option.onClick();
                                            close()
                                        }
                                    }}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                )}
            </Popover.Panel>
        </Popover>
    )
} 